import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Geist, Geist_Mono, Cormorant_Garamond } from 'next/font/google'

const geistSans = Geist({
    variable: '--font-sans',
    subsets: ['latin']
})

const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

const cormorant = Cormorant_Garamond({
    variable: '--font-hardback-serif',
    subsets: ['latin'],
    weight: ['300', '400', '500', '600', '700'],
    style: ['normal', 'italic']
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${geistSans.variable} ${geistMono.variable} ${cormorant.variable} h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App